"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomGroupingsByBrandAndSpecies = exports.CustomDisplayOrdersByBrand = void 0;
/*
Note if you don't specify an order for a brand it will
default to the order of the keys in ProductList
*/
var CustomDisplayOrdersByBrand = exports.CustomDisplayOrdersByBrand = {
  asia: ['Basic', 'Essential', 'Top'],
  bupa: ['Basic', 'Standard', 'Ultimate'],
  bwm: ['Nose-To-Tail', 'ComprehensiveFeline', 'ComprehensiveCanine', 'IndoorCat', 'Accident', 'PeaceOfMind', 'Ultimate'],
  cba: ['Classic', 'ClassicPlus'],
  greencross: ['Core', 'Total'],
  guardian: ['Bronze', 'Gold', 'Platinum'],
  guidedogs: ['Basic', 'Comprehensive', 'Premium'],
  hcf: ['Premium', 'PremiumPlus'],
  iag: ['Indoor', 'Basic', 'Standard', 'Premium'],
  kogan: ['Indoor', 'Primary', 'Luxury'],
  medibank: ['Protect', 'Plus', 'Max'],
  pia: ['Essentials', 'EssentialsStepDown', 'Comprehensive', 'Major'],
  pinscom: ['Bronze', 'Silver', 'Gold', 'Platinum'],
  prime: ['Imperial', 'Sovereign', 'Regal'],
  real: ['Standard', 'Classic', 'Premium'],
  rspca: ['Economy', 'General', 'Ultimate', 'UltimatePlus'],
  wow: ['Indoor', 'Basic', 'Standard', 'Comprehensive', 'ComprehensivePlus'],
  vetsown: ['Accident']
};
var CustomGroupingsByBrandAndSpecies = exports.CustomGroupingsByBrandAndSpecies = {
  pinscom: {
    FELINE: [{
      label: 'Specified conditions cover for indoor cats',
      productsGroups: ['Bronze']
    }, {
      label: 'Comprehensive accident & illness cover',
      productsGroups: ['Gold', 'Platinum']
    }],
    CANINE: [{
      label: 'Specified accidental injury & specified illness cover',
      productsGroups: ['Silver']
    }, {
      label: 'Comprehensive accident & illness cover',
      productsGroups: ['Gold', 'Platinum']
    }]
  }
};